import React, { useReducer } from "react";
import IdentityHelper from "../../utilities/IdentityHelper";
import AuthContext from "./authContext";
import AuthReducer from "./authReducer";

import {
	GET_AUTHENTICATION_DETAILS,
	OKTA_LOGIN_PAGE,
	SET_AUTHENTICATION_DETAILS,
} from "./types";

const AuthState = (props) => {
	const initialState = {
		authenticated: false,
		authenticatedLoading: false,
	};

	const [state, dispatch] = useReducer(AuthReducer, initialState);

	// Get Client Details
	const getAuthenticationDetails = (data) => {
		dispatch({ type: GET_AUTHENTICATION_DETAILS, payload: data });
	};

	const setAuthenticationDetails = (data) => {
		dispatch({ type: SET_AUTHENTICATION_DETAILS, payload: data });
	};

	const getOktaAccessToken = async () => {
		// const isDev = false;

		// if (isDev === true) {
		// 	return {
		// 		accessToken:
		// 			"eyJraWQiOiI1YTJ4ZV9IX0tSNnlDTlFDZi0ybTY3M2tCYjBfMG5Vd1VTbWNrbF9jcnRFIiwiYWxnIjoiUlMyNTYifQ.eyJ2ZXIiOjEsImp0aSI6IkFULlFiWldkMk9CVHBYSEJnWWFJSHNpLVptMVZWRF9NUnBrb0FFSDhMRUtvY28iLCJpc3MiOiJodHRwczovL2lkLmRldi5lbGlmZWluc3VyZS5jb20uYXUvb2F1dGgyL2RlZmF1bHQiLCJhdWQiOiJhcGk6Ly9kZWZhdWx0IiwiaWF0IjoxNzIzMjQ5MTA0LCJleHAiOjE3MjMyNTI3MDQsImNpZCI6IjBvYTI3Z3g2dTVlb3BlNW5TM2w3IiwidWlkIjoiMDB1Mzh5cXRkMThqcmxNeW0zbDciLCJzY3AiOlsidGxfY2FsbF9jZW50cmUiLCJvcGVuaWQiXSwiYXV0aF90aW1lIjoxNzIzMjQ4Nzc2LCJjY191c2VyIjp0cnVlLCJzdWIiOiJqY3FiIiwibGFzdE5hbWUiOiJCeXJuZSIsImZpcnN0TmFtZSI6IkNvbGluIiwiaXNVVyI6dHJ1ZX0.s15w64TDRZ_ZSikJl9Bt_1x94uDq1OLwt6e0zBT2RXiWZoUHvATWX8xP8kc0pgmygxeAgrbisU3I9gPv6mKYhkhpnJAm3N36s9FR_IrFYBuoZ8UaFmg8peUyOYFG5DfpMMR83bUNU9aFjUIT_Zy61MLV7XO09VZS6pTAgNxECIL44eKLORnQ_pfJigCHfbYCVyXePpJNJVQUKjcUlHASKi1VEPGGrbv-hAFCZcT0PnIO2SUi6B8Ga58LBXhHrPjUgIqgC0qqXtDLVYkrukOPr-9YEBVpKulVBPNN-DZJ_6ED22Sww4fH7z0sUdKEFngYp9Rj6ixKDH46fvFFZCWcXw",
		// 	};
		// }
		try {
			let oktaClient = IdentityHelper.getOktaAuthClient();
			let oktaAccessToken = await oktaClient.tokenManager.get("accessToken");
			if (
				oktaAccessToken &&
				!oktaClient.tokenManager.hasExpired(oktaAccessToken)
			) {
				return oktaAccessToken;
			} else {
				const { status, tokens } = await oktaClient.idx.authenticate();
				if (tokens && status === "SUCCESS") {
					oktaClient.tokenManager.setTokens(tokens);
					return tokens;
				} else {
					// Okta Session is expired, redirect to Okta page for login
					window.location.href = OKTA_LOGIN_PAGE;
				}
			}
		} catch (error) {
			IdentityHelper.clearStorage();
			window.location.href = OKTA_LOGIN_PAGE;
			console.error(error);
			throw error; // throw the error back to the calling method
		}
	};

	return (
		<AuthContext.Provider
			value={{
				authenticated: state.authenticated,
				authenticatedLoading: state.authenticatedLoading,
				getAuthenticationDetails,
				setAuthenticationDetails,
				getOktaAccessToken,
			}}
		>
			{props.children}
		</AuthContext.Provider>
	);
};

export default AuthState;
